export default __webpack_public_path__ + "static/media/class_vii_viii_ix.1bc02f9d.png";